import styled from "styled-components";

export const PiiNote = styled.p`
  font-size: 9px;
  color: grey;
  padding-left: 69px;
  margin: 0;
  text-align: right;
  padding-right: 10px;
  font-style: italic;
`;
